import { TypeOfClientsEnum } from '@shared/api/types';

export const clientTypeOptions = [
  {
    label: 'Local retailer',
    value: TypeOfClientsEnum['local_retailer'],
  },
  {
    label: 'Regional retailer',
    value: TypeOfClientsEnum['regional_retailer'],
  },
  {
    label: 'National retailer',
    value: TypeOfClientsEnum['national_retailer'],
  },
  {
    label: 'Retail wholesaler',
    value: TypeOfClientsEnum['retail_wholesaler'],
  },
  {
    label: 'Food-service wholesaler',
    value: TypeOfClientsEnum['food_service_wholesaler'],
  },
  {
    label: 'Restaurant',
    value: TypeOfClientsEnum['restaurant'],
  },
  {
    label: 'Caterer',
    value: TypeOfClientsEnum['caterer'],
  },
  {
    label: 'Consumer',
    value: TypeOfClientsEnum['consumer'],
  },
];
